import React, { Component } from "react";
import BaseModal, { ModalActions, SaveButton, CancelButton, DeleteButton } from "../../../../containers/UI/Modal/BaseModal";
import InputRow from "../../../configuration/Rows/InputRow/InputRow";
import SelectRow from "../../../configuration/Rows/SelectRow/SelectRow";
import FileRow from "../../../configuration/shared/FileRow/FileRow";
import ButtonRow from "../../../configuration/shared/ButtonRow/ButtonRow";
import CheckboxRow from "../../../configuration/shared/CheckboxRow/CheckboxRow";
import axios from "../../../../axios";
import classes from "./InvoiceModal.css";


class InvoiceModal extends Component {

  state = {
    invoice: {},
    options: { "Intracommunity": false, "Sent to Poisson": false },
    status: { "Deliverd to customer": false, "Invoice paid": false },
    uploadFile: null,
    valuesChanged: false,
    orderOptions: [],
    selectedFileName: null,
    generatedDraft: null,
    generatedIsBusy: false,
    generatedReadOnly: false,
    generatedVatRate: 21,
    generatedValidationError: "",
  }

  componentDidMount() {
    const createMode = this.props.selectedInvoice === null
    const generateMode = this.props.mode === "generate"
    const selectedInvoice = this.props.selectedInvoice

    if ((createMode && generateMode) || (!createMode && selectedInvoice && selectedInvoice.isGenerated)) {
      this.initGeneratedState(createMode, selectedInvoice)
      return
    }

    let invoice = selectedInvoice
    if (invoice === null) {
      let today = new Date()
      let invoiceDate = today.getTime() / 1000
      invoice = {
        intraCommunity: false,
        sentToAccountant: false,
        sentToCustomer: false,
        paid: false,
        invoiceReference: this.proposedReference(),
        invoiceDate: invoiceDate
      }
    }
    // Change dot to comma
    if (invoice.amountWithoutVAT) {
      invoice.amountWithoutVAT = invoice.amountWithoutVAT.toLocaleString("be-NL")
    }
    // Parse date
    if (invoice.invoiceDate) {
      invoice.invoiceDate = new Date(invoice.invoiceDate * 1000).toLocaleDateString("en-GB")
    }
    if (invoice.dueDate) {
      invoice.dueDate = new Date(invoice.dueDate * 1000).toLocaleDateString("en-GB")
    }

    this.setState({ 
      invoice: {...invoice},
      options: { "Intracommunity": invoice.intraCommunity, "Sent to Poisson": invoice.sentToAccountant },
      status: { "Deliverd to customer": invoice.sentToCustomer, "Invoice paid": invoice.paid },
      orderOptions: invoice.customer ? this.props.orderOptions[invoice.customer._id] ?? [] : []
    })
  }

  proposedReference = () => {
    const today = new Date()
    return this.props.proposedIndex + " - " + today.getFullYear().toString().slice(-2) + String(today.getMonth() + 1).padStart(2, '0') + String(today.getDate()).padStart(2, '0') + "01"
  }

  initGeneratedState = (createMode, invoice) => {
    const firstSupplier = (this.props.supplierEntityOptions && this.props.supplierEntityOptions[0] && this.props.supplierEntityOptions[0].value) || ""
    const rowsFromInvoice = invoice && Array.isArray(invoice.rows) && invoice.rows.length > 0
      ? invoice.rows.map((r) => ({
          description: r.description || "",
          quantity: r.quantity || 1,
          unitPrice: r.unitPrice || 0,
        }))
      : [{ description: "", quantity: 1, unitPrice: 0 }]

    const customerId = invoice && invoice.customer ? (invoice.customer._id || "") : ""
    const customer = this.props.customersById ? this.props.customersById[customerId] : null
    const isBelgian = !!customer && String(customer.country || "").toUpperCase() === "BE"

    this.setState({
      invoice: invoice ? { ...invoice } : {},
      generatedDraft: {
        customerId,
        supplierEntity: (invoice && invoice.supplierEntity) || firstSupplier,
        invoiceReference: (invoice && invoice.invoiceReference) || this.proposedReference(),
        orderReference: (invoice && invoice.orderReference) || "",
        currency: (invoice && invoice.currency) || "EUR",
        rows: rowsFromInvoice,
        sentToCustomer: !!(invoice && invoice.sentToCustomer),
        hasXml: !!(invoice && invoice.xmlContent),
      },
      generatedReadOnly: !createMode && !!(invoice && invoice.sentToCustomer),
      generatedVatRate: isBelgian ? 21 : 0,
    })
  }

  getInvoiceId = () => {
    const fromState = this.state.invoice && this.state.invoice._id
    const fromProps = this.props.selectedInvoice && this.props.selectedInvoice._id
    const raw = fromState || fromProps
    if (raw === undefined || raw === null) return null
    const id = String(raw)
    if (!id || id === "undefined" || id === "null") return null
    return id
  }

  getActiveInvoiceContext = () => {
    const invoiceId = this.getInvoiceId() || ""
    const active = (this.state.invoice && this.state.invoice._id)
      ? this.state.invoice
      : (this.props.selectedInvoice || {})
    return { activeInvoice: active, invoiceId }
  }

  deleteHandler = () => {
    // Sync to the backend
    axios.delete("/invoices/delete/" + this.state.invoice._id)
    // Close the modal view
    this.props.closeModal()
  }

  saveInvoiceHandler = () => {

    // Parse additional properties into invoice
    let invoice = this.state.invoice
    invoice.sentToCustomer = this.state.status["Deliverd to customer"]
    invoice.sentToAccountant = this.state.options["Sent to Poisson"]
    invoice.intraCommunity = this.state.options["Intracommunity"]
    invoice.paid = this.state.status["Invoice paid"]
    invoice.amountWithoutVAT = invoice.amountWithoutVAT !== undefined && invoice.amountWithoutVAT !== null
      ? String(invoice.amountWithoutVAT).replace(/,/g, '.')
      : null

    // Convert invoice date to unix seconds (supports DD/MM/YYYY, seconds, milliseconds).
    if (invoice.invoiceDate !== undefined && invoice.invoiceDate !== null && invoice.invoiceDate !== "") {
      if (typeof invoice.invoiceDate === "string") {
        var parts = invoice.invoiceDate.split("/")
        if (parts.length === 3) {
          var date = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10))
          invoice.invoiceDate = isNaN(date.getTime()) ? 0 : Math.round(date.getTime() / 1000)
        } else {
          invoice.invoiceDate = 0
        }
      } else if (typeof invoice.invoiceDate === "number") {
        invoice.invoiceDate = invoice.invoiceDate > 9999999999
          ? Math.round(invoice.invoiceDate / 1000)
          : Math.round(invoice.invoiceDate)
      } else {
        invoice.invoiceDate = 0
      }
    } else {
      invoice.invoiceDate = 0
    }

    // Sync to the backend
    if (this.state.valuesChanged) {
      axios.post("/invoices/update/verkoop", this.state.invoice)
    }

    // Close the modal view
    this.props.closeModal()
  }

  generateInvoiceHandler = async () => {
    const d = this.state.generatedDraft
    if (!d || !d.customerId) {
      this.setState({ generatedValidationError: "Please select a customer." })
      return
    }
    if (!d.supplierEntity) {
      this.setState({ generatedValidationError: "Please select a supplier entity." })
      return
    }
    const validRows = (d.rows || []).filter((r) => r.description && r.description.trim().length > 0 && Number(r.quantity) > 0 && Number(r.unitPrice) >= 0)
    if (validRows.length === 0) {
      this.setState({ generatedValidationError: "Please fill at least one row (description, quantity > 0, unit price >= 0)." })
      return
    }

    this.setState({ generatedIsBusy: true })
    try {
      await axios.post("/invoices/generate", {
        customerId: d.customerId,
        supplierEntity: d.supplierEntity,
        rows: validRows,
        invoiceReference: d.invoiceReference,
        orderReference: d.orderReference,
        currency: d.currency || "EUR",
      })
      this.props.closeModal()
    } catch (err) {
      this.setState({
        generatedValidationError: (err.response && err.response.data && err.response.data.message) || err.message || "Failed to generate invoice."
      })
    } finally {
      this.setState({ generatedIsBusy: false })
    }
  }

  markGeneratedAsSent = async () => {
    const invoiceId = this.getInvoiceId()
    if (!invoiceId) {
      alert("Could not mark invoice as sent: missing invoice ID.")
      return
    }
    try {
      await axios.put("/invoices/mark-sent/" + invoiceId)
      this.setState((prev) => ({
        generatedReadOnly: true,
        generatedDraft: { ...prev.generatedDraft, sentToCustomer: true }
      }))
      this.props.closeModal()
    } catch (err) {
      if (err && err.response && err.response.status === 401) {
        alert("Your session expired. Please log in again and retry.")
        return
      }
      alert((err.response && err.response.data && err.response.data.message) || err.message || "Failed to mark invoice as sent.")
    }
  }

  updateGeneratedDraft = (patch) => {
    this.setState((prev) => ({ generatedDraft: { ...prev.generatedDraft, ...patch } }))
  }

  updateGeneratedRow = (idx, patch) => {
    this.setState((prev) => {
      const rows = [...(prev.generatedDraft.rows || [])]
      rows[idx] = { ...rows[idx], ...patch }
      return { generatedDraft: { ...prev.generatedDraft, rows } }
    })
  }

  addGeneratedRow = () => {
    this.setState((prev) => ({
      generatedDraft: {
        ...prev.generatedDraft,
        rows: [...(prev.generatedDraft.rows || []), { description: "", quantity: 1, unitPrice: 0 }]
      }
    }))
  }

  removeGeneratedRow = (idx) => {
    this.setState((prev) => {
      const rows = [...(prev.generatedDraft.rows || [])]
      rows.splice(idx, 1)
      return {
        generatedDraft: {
          ...prev.generatedDraft,
          rows: rows.length ? rows : [{ description: "", quantity: 1, unitPrice: 0 }]
        }
      }
    })
  }

  downloadGeneratedXml = async () => {
    const invoiceId = this.getInvoiceId()
    if (!invoiceId) {
      alert("Could not download XML: missing invoice ID.")
      return
    }
    const activeInvoice = (this.state.invoice && this.state.invoice._id) ? this.state.invoice : (this.props.selectedInvoice || {})
    try {
      const response = await axios.get("/invoices/download-xml/" + invoiceId, { responseType: "blob" })
      const blob = new Blob([response.data], { type: "application/xml" })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = (activeInvoice.invoiceReference || invoiceId) + ".xml"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    } catch (err) {
      alert((err.response && err.response.data && err.response.data.message) || err.message || "Could not download XML.")
    }
  }

  /**
   * Parse sales invoice filename to extract reference and invoice date
   * Expected format: "INDEX - YYMMDDXX CUSTOMER" (e.g., "81 - 25121501 MCS")
   */
  parseSalesFilename = (filename) => {
    try {
      // Remove .pdf extension
      const baseName = filename.replace(/\.pdf$/i, '').replace(/\s*\(\d+\)$/, '').trim()
      
      // Match pattern: INDEX - YYMMDDXX CUSTOMER
      const match = baseName.match(/^(\d+)\s*-\s*(\d{8})(?:\s+.*)?$/)
      
      if (match) {
        const [, index, dateCode] = match
        const reference = `${index} - ${dateCode}`
        
        // Parse date from YYMMDDXX format
        const year = parseInt(dateCode.substring(0, 2), 10)
        const month = parseInt(dateCode.substring(2, 4), 10)
        const day = parseInt(dateCode.substring(4, 6), 10)
        
        // Validate date parts
        if (month < 1 || month > 12 || day < 1 || day > 31) {
          return null
        }
        
        // Format invoice date as DD/MM/YYYY
        const invoiceDate = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/20${String(year).padStart(2, '0')}`
        
        return {
          reference,
          invoiceDate
        }
      }
    } catch (e) {
      console.warn('Could not parse sales invoice filename:', filename, e)
    }
    return null
  }

  uploadPDF = (event, thisRef) => {
    const file = event.target.files[0]
    if (!file) return

    // Track the selected filename for visual feedback
    thisRef.setState({ selectedFileName: file.name })

    // In create mode, try to parse filename for autofill
    const createMode = thisRef.props.selectedInvoice === null
    
    if (createMode) {
      const parsed = thisRef.parseSalesFilename(file.name)
      
      if (parsed) {
        // Autofill reference and invoice date (user can still edit)
        thisRef.setState(prevState => ({
          invoice: {
            ...prevState.invoice,
            invoiceReference: parsed.reference,
            invoiceDate: parsed.invoiceDate
          },
          valuesChanged: true
        }))
      }
    }

    // Read the file's contents
    var reader = new FileReader();
    reader.addEventListener("load", function() {
      // Save uploaded PDF
      let pdfContent = reader.result.split("base64,")[1]
      thisRef.updateProperty("pdfContent", pdfContent)
    })
    reader.readAsDataURL(file)
  }

  downloadPDFhandler = () => {
    const invoiceId = this.getInvoiceId()
    const activeInvoice = (this.state.invoice && this.state.invoice._id) ? this.state.invoice : (this.props.selectedInvoice || {})

    if (!invoiceId) {
      alert("Could not download invoice: invoice ID not found. Please close and reopen the invoice.")
      return
    }

    // Request the PDF from the backend first (lazy fetch)
    axios.get("/invoices/pdf/" + invoiceId).then(response => {
      if (response.data) {

        if (response.data.pdfContent) {
          // Download PDF file
          const fileName = (activeInvoice.invoiceReference || "invoice") + ".pdf"
          const href = "data:application/pdf;base64," + response.data.pdfContent
          const link = document.createElement("a")
          link.href = href
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          return 

        } 
      }
      alert("No PDF file was attached to this invoice entry.")

    }).catch((err) => {
      alert("Could not download invoice: " + err.message)
    })
  }

  updateProperty(property, value) {
    let newState = { invoice: {...this.state.invoice}, valuesChanged: true }
    newState.invoice[property] = value

    if (property === "customer") {
      // Reset order and update order options if customer changes
      newState.orderOptions = this.props.orderOptions[value._id] ?? []
      newState.invoice.order = []
    }

    // Update state
    this.setState(newState)
  }


  render() {
    let createMode = (this.props.selectedInvoice === null)
    const generateCreateMode = createMode && this.props.mode === "generate"
    const generatedExistingMode = !createMode && this.props.selectedInvoice && this.props.selectedInvoice.isGenerated
    const generatedMode = generateCreateMode || generatedExistingMode

    // Calculate total amount with VAT
    let showTotal = false
    let totalAmount = 0
    if (this.state.invoice.amountWithoutVAT !== undefined && this.state.invoice.amountWithoutVAT !== null && this.state.invoice.amountWithoutVAT !== "") {
      let numericWithoutVAT = String(this.state.invoice.amountWithoutVAT).replace(/,/g, '.')
      if (!isNaN(numericWithoutVAT)) {
        if (this.state.options.Intracommunity) {
          totalAmount = parseFloat(numericWithoutVAT)
        } else {
          totalAmount = Math.round(parseFloat(numericWithoutVAT) * 121) / 100
        }
        showTotal = true
      } else {
        showTotal = false
      }
    }

    // Calculate and show dueDate based on invoiceDate
    let showDueDate = false
    let dueDateDisplay = ""
    
    if (this.state.invoice.invoiceDate !== undefined && this.state.invoice.invoiceDate !== null && this.state.invoice.invoiceDate !== "") {
      const rawInvoiceDate = this.state.invoice.invoiceDate
      let invoiceDate = null

      if (typeof rawInvoiceDate === "string") {
        const parts = rawInvoiceDate.split("/")
        if (parts.length === 3) {
          invoiceDate = new Date(parseInt(parts[2], 10), parseInt(parts[1], 10) - 1, parseInt(parts[0], 10))
        }
      } else if (typeof rawInvoiceDate === "number") {
        // Backend dates are usually unix seconds, but support ms as well.
        const ts = rawInvoiceDate > 9999999999 ? rawInvoiceDate : rawInvoiceDate * 1000
        invoiceDate = new Date(ts)
      }

      if (invoiceDate && !isNaN(invoiceDate.getTime())) {
        const dueDate = new Date(invoiceDate.getTime() + (30 * 24 * 60 * 60 * 1000))
        dueDateDisplay = dueDate.toLocaleDateString("en-GB")
        showDueDate = true
      }
    }


    if (generatedMode && this.state.generatedDraft) {
      const d = this.state.generatedDraft
      const selectedCustomer = this.props.customersById ? this.props.customersById[d.customerId] : null
      const vatRate = selectedCustomer && String(selectedCustomer.country || "").toUpperCase() === "BE" ? 21 : 0
      const rows = d.rows || []
      const subtotal = rows.reduce((sum, r) => sum + (Number(r.quantity) || 0) * (Number(r.unitPrice) || 0), 0)
      const vatAmount = Number(((subtotal * vatRate) / 100).toFixed(2))
      const total = Number((subtotal + vatAmount).toFixed(2))
      const readOnly = this.state.generatedReadOnly || generatedExistingMode

      return (
        <BaseModal
          isOpen={this.props.shouldShow}
          onClose={this.props.closeModal}
          size="ultrawide"
          title={generateCreateMode ? "Generate invoice" : "Generated invoice"}
        >
          <SelectRow
            title="Customer"
            firstRow
            ultrawide
            value={d.customerId || ""}
            onChange={(newValue) => this.updateGeneratedDraft({ customerId: newValue ? newValue.value : "" })}
            options={this.props.customersOptions}
          />
          <SelectRow
            title="Supplier entity"
            firstRow
            ultrawide
            marginBottom="10px"
            value={d.supplierEntity || ""}
            onChange={(newValue) => this.updateGeneratedDraft({ supplierEntity: newValue ? newValue.value : "" })}
            options={this.props.supplierEntityOptions || []}
          />
          <InputRow
            title="Invoice reference"
            enabled={!readOnly}
            ultrawide
            value={d.invoiceReference || ""}
            placeholder="E.g. 1 - 24010101"
            onChange={(event) => this.updateGeneratedDraft({ invoiceReference: event.target.value })}
          />
          <InputRow
            title="Order reference"
            enabled={!readOnly}
            ultrawide
            value={d.orderReference || ""}
            placeholder="Optional order reference"
            onChange={(event) => this.updateGeneratedDraft({ orderReference: event.target.value })}
          />

          <div className={classes.generatedRowsSection}>
            <div className={classes.generatedRowsHeader}>
              <span>Invoice rows</span>
              {!readOnly && <button className={classes.smallActionButton} onClick={this.addGeneratedRow}>Add row</button>}
            </div>
            <table className={classes.rowsTable}>
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Unit price</th>
                  <th>Quantity</th>
                  <th>Row total</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, idx) => {
                  const rowTotal = (Number(row.quantity) || 0) * (Number(row.unitPrice) || 0)
                  return (
                    <tr key={idx}>
                      <td>
                        <input
                          className={classes.tableInput}
                          disabled={readOnly}
                          placeholder="Description"
                          value={row.description || ""}
                          onChange={(e) => this.updateGeneratedRow(idx, { description: e.target.value })}
                        />
                      </td>
                      <td>
                        <input
                          className={classes.tableInput}
                          disabled={readOnly}
                          type="number"
                          min="0"
                          step="0.01"
                          placeholder="0.00"
                          value={row.unitPrice}
                          onChange={(e) => this.updateGeneratedRow(idx, { unitPrice: e.target.value })}
                        />
                      </td>
                      <td>
                        <input
                          className={classes.tableInput}
                          disabled={readOnly}
                          type="number"
                          min="1"
                          step="1"
                          placeholder="1"
                          value={row.quantity}
                          onChange={(e) => this.updateGeneratedRow(idx, { quantity: e.target.value })}
                        />
                      </td>
                      <td>€ {rowTotal.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      {!readOnly && (
                        <td>
                          {rows.length > 1 && (
                            <button className={classes.smallDangerButton} onClick={() => this.removeGeneratedRow(idx)}>Remove</button>
                          )}
                        </td>
                      )}
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>

          {this.state.generatedValidationError && (
            <div className={classes.generatedValidationError}>{this.state.generatedValidationError}</div>
          )}

          <div className={classes.generatedTotals}>
            <div>VAT rate: <strong>{vatRate}%</strong> ({vatRate === 21 ? "Belgian customer" : "Non-Belgian customer"})</div>
            <div>Subtotal: <strong>€ {subtotal.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
            <div>VAT: <strong>€ {vatAmount.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
            <div>Total: <strong>€ {total.toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong></div>
          </div>

          {!generateCreateMode && (
            <div className={classes.generatedActions}>
              <label className={classes.sentLabel}>
                <input
                  type="checkbox"
                  checked={!!d.sentToCustomer}
                  disabled={!!d.sentToCustomer}
                  onChange={(e) => {
                    if (e.target.checked) this.markGeneratedAsSent()
                  }}
                />
                Sent out
              </label>

              {!this.props.selectedInvoice.intraCommunity && (
                <button className={classes.smallActionButton} onClick={this.downloadGeneratedXml}>Download XML</button>
              )}

              <button className={classes.smallActionButton} onClick={this.downloadPDFhandler}>Download PDF</button>
            </div>
          )}

          <ModalActions>
            {generateCreateMode ? (
              <>
                <CancelButton onClick={this.props.closeModal} />
                <SaveButton onClick={this.generateInvoiceHandler} disabled={this.state.generatedIsBusy}>
                  {this.state.generatedIsBusy ? "Generating..." : "Generate"}
                </SaveButton>
              </>
            ) : (
              <>
                <CancelButton onClick={this.props.closeModal}>Close</CancelButton>
                {!this.state.generatedReadOnly && <DeleteButton onClick={this.deleteHandler} />}
              </>
            )}
          </ModalActions>
        </BaseModal>
      )
    }

    return (
      <BaseModal 
        isOpen={this.props.shouldShow} 
        onClose={this.props.closeModal}
        title={createMode ? "Upload new invoice" : "Edit invoice"}
      >
        <SelectRow
          title="Customer"
          firstRow
          ultrawide
          value={this.state.invoice.customer ? (this.state.invoice.customer._id ?? "") : ""}
          onChange={(newValue) => this.updateProperty("customer", { _id: newValue.value })}
          options={this.props.customersOptions}/>
        <SelectRow
          title="Order"
          firstRow
          ultrawide
          isMulti
          value={this.state.invoice.order}
          onChange={(valueArray) => this.updateProperty("order", valueArray.map(option => option.value))}
          options={this.state.orderOptions}/>
        <InputRow
          title="Reference"
          enabled
          ultrawide
          value={this.state.invoice.invoiceReference ?? ""}
          placeholder={"E.g. 1 - 2024011501"}
          onChange={(event) => this.updateProperty("invoiceReference", event.target.value)}/>
        <InputRow
          title="Invoice date"
          enabled
          ultrawide
          value={this.state.invoice.invoiceDate ?? ""}
          placeholder={"E.g. 15/01/2024"}
          onChange={(event) => this.updateProperty("invoiceDate", event.target.value)}/>
        {showDueDate &&
        <InputRow
          title="Due date"
          enabled={false}
          ultrawide
          value={dueDateDisplay}/>}
        <InputRow
          title="Amount excl. VAT"
          enabled
          ultrawide
          value={this.state.invoice.amountWithoutVAT ?? ""}
          placeholder={"Amount"}
          onChange={(event) => this.updateProperty("amountWithoutVAT", event.target.value)}/>
        {showTotal &&
        <InputRow
          title="Total invoice amount"
          enabled={false}
          ultrawide
          value={"€ " + totalAmount.toLocaleString("de-DE")}/>}
        <CheckboxRow
          title="Options"
          options={this.state.options}
          optionChanged={(option, checked) => {
            let options = {...this.state.options}
            options[option] = checked
            this.setState({ options: options, valuesChanged: true })
          }}/>
        <CheckboxRow
          title="Status"
          options={this.state.status}
          optionChanged={(option, checked) => {
            let status = {...this.state.status}
            status[option] = checked
            this.setState({ status: status, valuesChanged: true })
          }}/> 

        {!createMode &&
        <ButtonRow
          title="Download invoice PDF"
          ultrawide
          body="Download .pdf file"
          onClick={this.downloadPDFhandler}/>}

        <FileRow
          title={createMode ? "Upload invoice PDF" : "Replace invoice PDF"}
          body={"Choose .pdf file"}
          inputId="salesInvoicePdfInput"
          selectedFileName={this.state.selectedFileName}
          onClick={(pdf) => this.uploadPDF(pdf, this)}
          extension=".pdf"/>

        <ModalActions>
          {(this.state.valuesChanged || createMode) ? (
            <>
              <CancelButton onClick={this.props.closeModal}/>
              {!createMode && <DeleteButton onClick={this.deleteHandler}/>}
              <SaveButton onClick={this.saveInvoiceHandler}>
                {createMode ? "Upload" : "Save"}
              </SaveButton>
            </>
          ) : (
            <>
              <CancelButton onClick={this.saveInvoiceHandler}>Close</CancelButton>
              <DeleteButton onClick={this.deleteHandler}/>
            </>
          )}
        </ModalActions>
      </BaseModal>
    );
  }
}

export default InvoiceModal;
